export const DYNAMIC_TAGS = [
  {
    text: 'Account Name',
    key: 'accountName'
  },
  {
    text: 'Account ID',
    key: 'accountCode'
  },
  {
    text: 'Phone Number',
    key: 'phoneNumber'
  },
  {
    text: 'Email',
    key: 'email'
  },
  {
    text: 'Address',
    key: 'address'
  },
  {
    text: 'Company Name',
    key: 'companyName'
  }
]

function formatClientAddress (client) {
  const line = [client.addressline1, client.addressline2].filter(Boolean).join(' ')
  const region = [client.city, client.state, client.zip].filter(Boolean).join(', ')
  return [line, region].filter(Boolean).join(', ')
}

export function getDynamicTagValue (tagKey, client, companyName = '') {
  if (!client) return ''

  switch (tagKey) {
    case 'accountName':
      return client.name || client.accountName || ''
    case 'accountCode':
      return client.customId || client.code || client.accountCode || ''
    case 'phoneNumber':
      return client.prettyPrimaryPhone ||
        client.primaryPhone ||
        client.phoneNumber ||
        client.phone ||
        ''
    case 'email':
      return client.email || ''
    case 'address':
      return client.address || formatClientAddress(client)
    case 'companyName':
      return companyName || client.companyName || ''
    default:
      return ''
  }
}
